import styled from 'styled-components';

export const TitleContainer = styled.div`
  font-family: 'MabryPro';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9c9c9c;

  height: 28px;
  border-bottom: 1px solid #555555;
`;

export const ChildrenContainer = styled.div`
  padding-top: 24px;
  font-size: 18px;
  line-height: 28px;

  color: #f2f2f2;
`;
